module.exports = __webpack_public_path__ + "img/s2P36.b8926d0a.png";